export class CreateFabricTableShortcutDemoRequestShortcutsInner {
    'name';
    'resourceId';
    'vaultId';
    'snapshotId';
    'tableName';
    'dbName';
    'schemaName';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "resourceId",
            "baseName": "resource_id",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "vaultId",
            "baseName": "vault_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "snapshotId",
            "baseName": "snapshot_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "tableName",
            "baseName": "table_name",
            "type": "string",
            "format": ""
        },
        {
            "name": "dbName",
            "baseName": "db_name",
            "type": "string",
            "format": ""
        },
        {
            "name": "schemaName",
            "baseName": "schema_name",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CreateFabricTableShortcutDemoRequestShortcutsInner.attributeTypeMap;
    }
    constructor() {
    }
}
